import React from 'react'

const TestSeries = () => {
  return (
    <div>
      Test Series Page
    </div>
  )
}

export default TestSeries
